import React from "react";
import { Container, Graphics } from "@pixi/react";
import { useSelector, useDispatch } from "react-redux";
import ButtonSound from "../Buttons/ButtonSound";
import ButtonMenu from "../Buttons/ButtonMenu";
import { useToolbarDimensionsV2 } from "../../../../Hooks/useToolbarDimensionsV2";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import Clock from "../../primary/Other/Clock";
import CompanyLogo from "../CompanyLogo/CompanyLogo";
import ButtonGameRules from "../Buttons/ButtonGameRules";
import ButtonPaytable from "../Buttons/ButtonPaytable";
import ButtonSettings from "../Buttons/ButtonSettings";
import ButtonHome from "../Buttons/ButtonHome";
import { selectMenuActive } from "../../../../State/selectors";
import { closeMenu } from "../../../../State/actions";

const ToolbarTop = () => {
  const toolbar = useToolbarDimensionsV2();
  const { dimensions } = useDimensions();
  const menuActive = useSelector(selectMenuActive);
  const dispatch = useDispatch();

  const handleClickOutside = () => {
    dispatch(closeMenu());
  };

  return (
    <Container
      name="secondary_toolbar_top"
      x={(dimensions.width - toolbar.width) / 2}
      sortableChildren={true}
      y={0}
      zIndex={1}
    >
      {/* Invisible clickable background when menu is active - closes menu when clicked */}
      {menuActive && (
        <Graphics
          name="menu_click_outside"
          zIndex={0}
          draw={(g) => {
            g.clear();
            g.beginFill(0x000000, 0.001); // Nearly transparent but still interactive
            g.drawRect(
              -(dimensions.width - toolbar.width) / 2,
              0,
              dimensions.width,
              dimensions.height,
            );
            g.endFill();
          }}
          eventMode="static"
          onpointertap={handleClickOutside}
        />
      )}

      <ButtonMenu />
      <ButtonGameRules />
      <ButtonPaytable />
      <ButtonSettings />
      <ButtonHome />

      <CompanyLogo toolbar={toolbar} />
      <ButtonSound toolbar={toolbar} />
      <Clock toolbar={toolbar} />
    </Container>
  );
};

export default ToolbarTop;
